export const GET_SUBSCRIPTIONS = '[Subscription Action] Get subscriptions';
export const CONFIRMED_GET_SUBSCRIPTIONS = '[Subscription Action] Confirmed Get subscriptions';
